interface Message {
  [key: string]: any
}

class MessageQueue {
  private queue: Map<string, Message>

  constructor() {
    this.queue = new Map<string, Message>()
  }

  send(eventName: string, message: Message): void {
    this.queue.set(eventName, message)
  }

  receive(eventName: string): Message | undefined {
    const message = this.queue.get(eventName)
    this.queue.delete(eventName)
    return message
  }

  clearAll(): void {
    this.queue.clear()
  }

  clear(eventName: string): void {
    this.queue.delete(eventName)
  }
}

export default new MessageQueue()
